import constants from "./constants";
import UIUtils from "./util/UIUtils";

export default {
  validators: {
    validatorsList: "List of " + constants.app.appName + " validators",
  },
  stats: {
    stakingPools: "# of validators",
    recentBlock: "Latest block # when dashboard was updated"
  },
  netstats: {
    totalStake: UIUtils.getTip("Total Staked $ATOM (only counting bonded validators)"),
    apr: UIUtils.getTip("Current expected APR - based on annual inflation, current total stake, & zero commission"),
    activeAccounts: UIUtils.getTip("Chart showing how non-zero balance active addresses count changes over time"),
    uniqueDelegates: UIUtils.getTip("Total number of unique delegates/stakers."),
    totalValidators: UIUtils.getTip("Total number of validators (including jailed/unbonded)."),
    delegations: UIUtils.getTip("Total number of active delegations."),
    gini: UIUtils.getTip("Gini coefficient is a metric used to describe the level of inequality of stake between all validators"),
    usdPrice: UIUtils.getTip("USD price of $ATOM"),
    valForNetworkHalt: UIUtils.getTip("The smallest number of validators that together control more than 33% of the voting power."),
    medianCommission: UIUtils.getTip("Median and weighted median of the commission charged by all validators."),
  },
  networkCharts: {
    signHistory: UIUtils.getTip("Chart showing the signing history for each block produced. Data elements shown are: signed/missed - how many validators signed/missed a block. networkSignRate - %age of validators that signed a particular block."),
  },
  valDetails: {
    basic: UIUtils.getTip("Basic details of the validator"),
    valAssess: UIUtils.getTip("Various non-performance aspects for assessing validators"),
    address: UIUtils.getTip("Address details"),
    perfSummary: UIUtils.getTip("Validator performance summary in different timeframe. This data does not use completed days and presents validator performance counted backwards from this moment"),
    maxCommission: UIUtils.getTip("Max Commission - represents the maximum commission that validator can ever charge on rewards earned from staking."),
    maxCommissionChangeRate: UIUtils.getTip("Max Commission Change Rate - The max daily change in commission that validator can do."),

  },
  valDetailsCharts: {
    hourlySignPer: UIUtils.getTip("Chart showing hourly block sign percentages for the validator."),
    hourlySigns: UIUtils.getTip("Chart showing hourly block signatures for the validator."),
    dailySignPer: UIUtils.getTip("Chart showing daily block sign percentages for the validator."),
    dailySigns: UIUtils.getTip("Chart showing daily block signatures for the validator."),
  },
  airdrop: {
    airdrops: UIUtils.getTip("Currently active airdrops for " + constants.app.appName + " stakers."),
  },
  network: {
    details: UIUtils.getTip("Details of the currently selected network including staking aspects"),
    metrics: UIUtils.getTip("Decentralization metrics details of the currently selected network"),
    delegations: UIUtils.getTip("Delegation stats for the currently selected network"),
    undelegations: UIUtils.getTip("Undelegation stats for the currently selected network"),
  }
};
// Click more/less to change the timeframe for chart.



// WEBPACK FOOTER //
// ./src/tooltips.js